export interface Conversation {
  id: string;
  conversation: string;
  updated: Date;
  created: Date;
  name: string | null;
  participants: string[] | null;
}

export interface EmailAddressModel {
  name: string;
  address: string;
}

export interface EmailListItem {
  id: string;
  from: EmailAddressModel;
  //to: ContactModel[];
  subject: string;
  //created: Date;
  sent: Date;
  attachments: number;
}

export interface TagRefModel {
  id: string;
  path: string;
  source: string;
}

export interface EmailModel {
  id: string;
  from: EmailAddressModel;
  to: EmailAddressModel[];
  cc: EmailAddressModel[];
  bcc: EmailAddressModel[];
  subject: string;
  text: string;
  trimmed: string;
  created: Date;
  sent: string;
  media: Media[];
  attachments: number;
}

export interface Media {
  attachment: boolean;
  fileName: string;
  fileUrl: string; //deprecated
  filePath: string;
  size: string;
}

export interface MediaModel {
  id: string;
  contentDisposition: string | null;
  contentType: string;
  title: string;
  size: number | null;
}

export interface Participant {
  id: string;
  created: Date;
  updated: Date;
}

// Define the shape of a message
export interface Message {
  id: string;
  conversation: string;
  content: string | any[];
  created: Date;
  from: string;
  type: string;
  attachments: number;
  sending: boolean | false;
  error: boolean | false;
  multiline: boolean;
  previousId: string;
}

export interface TagValueModel {
  name: string;
  label: string;
  hint: string;
  path: string;
  group: string;
  ordinal: number;
  description: string | null;
}

export interface TagScopesModel {
  name: string;
  label: string;
  values: TagValueModel[];
  ordinal: number;
}

export interface TagModel {
  id: string;
  name: string;
  description: string | null;
  scopes: TagScopesModel[];
}

import { icons } from "lucide-react";
export type IconName = keyof typeof icons;

export interface TagOption {
  name: string;
  color: string;
  label: string;
  filter?: (value: string, search: string, keywords?: string[]) => number;
  lock: boolean;
  icon: IconName;
}

export interface ContactSummary {
  headline: string;
  location: string;
  summary: string;
  business: { website: string; name: string; summary: string };
  options: { type: string; purpose: string; value: string }[];
}

export interface ContactModel {
  id: string;
  jcard?: any;
  summary?: string;
}

export interface SSEMessage {
  event: string;
  //data: any;
  type: string;
  response: any;
}

export enum UploadStatus {
  Pending = "Pending",
  Uploading = "Uploading",
  Success = "Success",
  Error = "Error",
}

export type FileItem = {
  id: string; // client temp id or server id once uploaded
  filename: string;
  size: number;
  contentType: string;
  type: string;
  progress: number; // 0..100
  status: UploadStatus;
  error?: string;
  project: string;
};

export type EstimateItem = {
  description: string;
  quantity: number;
  unitPrice: number;
  csiCode: string;
};

export type StreetAddress = {
  houseNumber: string;
  city: string;
  state: string;
  zip4: string;
};

export type ContactInfoModel = {
  name: string;
  streetAddress: StreetAddress;
  emailAddress: string;
  phoneNumber: string;
};

export type EstimateModel = {
  vendor: ContactInfoModel;
  recipient: ContactInfoModel;
  billable: ContactInfoModel;
  id: string;
  createDate: string;
  totalPrice: number;
  summary: string;
  qualifications: string[];
  openItems: string[];
  lineItems: EstimateItem[];
};
